export default __webpack_public_path__ + "static/media/m-service3.15ddab6d.svg";